class ScrollReveal {
  constructor() {
    this.init();
  }

  init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('[data-reveal], [data-reveal-child]').forEach(el => {
        el.setAttribute('data-revealed', 'true');
      });
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -50px 0px',
      threshold: 0.15
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          
          if (el.hasAttribute('data-reveal-stagger')) {
            const children = el.querySelectorAll('[data-reveal-child]');
            children.forEach((child, index) => {
              const delay = (index * 100) + parseInt(el.getAttribute('data-reveal-delay') || 0);
              child.style.setProperty('--reveal-delay', `${delay}ms`);
              
              const duration = el.getAttribute('data-reveal-duration');
              if (duration) {
                child.style.setProperty('--reveal-duration', `${duration}ms`);
              }
              
              requestAnimationFrame(() => {
                child.setAttribute('data-revealed', 'true');
              });
            });
            el.setAttribute('data-revealed', 'true');
            obs.unobserve(el);
          } else {
            const delay = el.getAttribute('data-reveal-delay');
            if (delay) el.style.setProperty('--reveal-delay', `${delay}ms`);
            
            const duration = el.getAttribute('data-reveal-duration');
            if (duration) el.style.setProperty('--reveal-duration', `${duration}ms`);

            requestAnimationFrame(() => {
              el.setAttribute('data-revealed', 'true');
            });
            obs.unobserve(el);
          }
        }
      });
    }, observerOptions);

    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(el => {
      observer.observe(el);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ScrollReveal());
} else {
  new ScrollReveal();
}

export default ScrollReveal;
